import { Checkbox } from 'components/form/checkbox'

export const MenuItem = ({
  checked,
  indeterminate,
  label,
  onChange,
}: {
  checked: boolean
  indeterminate?: boolean
  label: string
  onChange: (checked: boolean) => void
}) => {
  return (
    <label className="flex flex-row items-center w-full h-full cursor-pointer">
      <Checkbox
        checked={checked}
        indeterminate={indeterminate}
        onChange={() => {
          onChange(!checked)
        }}
        className="mr-2"
      />
      {label}
    </label>
  )
}
